import { Okr } from './../shared/interfaces/okr.interface';
import { OkrByAttrybute } from './../shared/interfaces/okr-by-attrybute';
import { Injectable } from '@angular/core';
import { BackendService } from '@tg4/http-infrastructure/dist/src';
import { AuthService } from '../shared/services/auth.service';
import { Observable } from 'rxjs';
import { OkrObjective } from '../shared/interfaces/okr-objective.interface';
import { UserPreview } from '../shared/interfaces/user-preview.interface';
import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SharedService } from '../shared/services/shared.service';
import { ConfigService } from '../shared/services/multi-clients/config.service';

@Injectable({
  providedIn: 'root',
})
export class OkrService {
  apiUrl: string;
  constructor(private _httpService: BackendService,
    private authService: AuthService,
    private http: HttpClient,
    private _sharedService: SharedService,
    private _configService: ConfigService
) {
    this.apiUrl = this._configService.settings.apiUrl;
}

  // GET

  public getObjectivesFrontPage(attributeID?): Observable<any> {
    return this._httpService.get(
      'getOkrObjectivesFrontPage',
      [],
      [{ name: 'AttributeId', value: attributeID ? attributeID : '' as any }]
    );
  }

  public getObjectivesByAttributes(SearchKey: string): Observable<any> {
    return this._httpService.get('getOKRObjectivesByAttributes', [], [
      { 'name': 'SearchKey', 'value': SearchKey as any }
    ]);
  }

  public getObjectives(AttributeID: number): Observable<any> {
    return this._httpService.get(
      'getOKRObjectives',
      [],
      [{ name: 'AttributeID', value: AttributeID as any }]
    );
  }

  public getKeyResult(keyResultid: number): Observable<any> {
    return this._httpService.get(
      'getOkrKeyResult',
      [],
      [{ name: 'KeyResultId', value: keyResultid as any }]
    );
  }

  public getVisibilities(SearchKey: string): Observable<any> {
    return this._httpService.get(
      'getOkrVisibilities',
      [],
      [{ name: 'SearchKey', value: SearchKey as any }]
    );
  }

  // POST

  public addObjective(objective: OkrObjective): Observable<any> {
    return this._httpService.post('addOkrObjective', {
      Objective: objective,
    });
  }

  public addKeyResultProgress(
    KeyResultID: number,
    ProgressDate: Date,
    Progress: number
  ): Observable<any> {
    return this._httpService.post('addKeyOKRKeyResultProgress', {
      KeyResultId: KeyResultID,
      ProgressDate: ProgressDate,
      Progress: Progress,
    });
  }

  public addVisibility(
    AttributeID: number,
    VisibleToAttributeID: number
  ): Observable<any> {
    return this._httpService.post('addOkrVisibility', {
      AttributeID: AttributeID,
      VisibleToAttributeID: VisibleToAttributeID,
    });
  }

  public ExportKeyResultByAttribute(): Observable<any> {
    return this.downloadFile({});
  }

  downloadFile(data: any): any {
    const applicationsUrl = `${this.apiUrl}/api/OKR/ExportKeyResultByAttribute`;
    const user = this.authService.getLoggedUser();
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': user.access_token,
        'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }),
      observe: 'response' as 'body',
      responseType: 'blob' as 'json'
    };

    const impersonatedUser: UserPreview | null = this.authService.getImpersonatedUser();
    if (impersonatedUser && impersonatedUser.userId) {
      options.headers['UserIdToImpersonate'] = impersonatedUser.userId;
    }
    return this.http.post(applicationsUrl, data, options)
      .pipe(map((res) => this._sharedService.downloadFile(res)));
  }

  // DELETE

  public deleteObjectives(AttributeID: number): Observable<any> {
    return this._httpService.delete('deleteOkrObjectives', [
      { name: 'AttributeId', value: AttributeID as any },
    ]);
  }

  public deleteVisibility(ID: number
  ): Observable<any> {
    return this._httpService.delete('deleteOkrVisibility', [
      { name: 'ID', value: ID as any }
    ]);
  }

  // UPDATE

  public updateObjective(okr: Okr): Observable<any> {
    return this._httpService.put('updateOkrObjective', {
      'objectives': okr.objectives,
      'attributeId': okr.attributeId
    });
  }

  public updateKeyResultComment(KeyResultId: number, KeyResultComment: string): Observable<any> {
    return this._httpService.put('updateKeyResultComment', {
      'KeyResultId': KeyResultId,
      'Comment': KeyResultComment
    });
  }
}
